import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14413a48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "worp" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "worp_hint" }, "开启后，只有正确输入观看码后才能观看直播", -1))
const _hoisted_3 = { class: "worp_swt" }

import { computed } from 'vue';
import { useStore } from 'vuex';
// import http from '@/api/live';
import { message } from 'ant-design-vue';

// 授权观看子组件----->密码观看-------PasswordWatch（密码观看）
const __default__ = { name: 'PasswordWatch' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();
const form = computed(() => store.state.authorizView.liveView);
const updateForm = (type: number) => {
  if (form.value.password_watch) {
    message.destroy();
    store.commit('authorizView/updateChildSwitch');
    if (!type) store.commit('authorizView/checkPassSwitch');
  }
  store.commit('authorizView/updateViewForm', form.value);
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_switch = _resolveComponent("a-switch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createTextVNode(" 弹窗标题："),
        _createVNode(_component_a_input, {
          value: _unref(form).title,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).title) = $event)),
          placeholder: "默认为‘密码观看’",
          class: "worp_in",
          onInput: _cache[1] || (_cache[1] = ($event: any) => (updateForm(1)))
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", null, [
        _createTextVNode(" 弹窗密码："),
        _createVNode(_component_a_input, {
          value: _unref(form).password_setting,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).password_setting) = $event)),
          placeholder: "请输入密码",
          class: "worp_in",
          onInput: _cache[3] || (_cache[3] = ($event: any) => (updateForm(2)))
        }, null, 8, ["value"])
      ]),
      _hoisted_2
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createTextVNode(" 功能开关： "),
      _createVNode(_component_a_switch, {
        checked: _unref(form).password_watch,
        "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).password_watch) = $event)),
        onChange: _cache[5] || (_cache[5] = ($event: any) => (updateForm(0)))
      }, null, 8, ["checked"])
    ])
  ], 64))
}
}

})